module.exports = __webpack_public_path__ + "static/media/s_white.3d9aba26.mp3";